
export class User {
  public userName: string = '';
  public userId : number = 0;
  public firstName: string = '';
  public lastName: string = '';
  public email: string = '';
  public password: string = '';
  public phone: string = '';
  public phoneNumberValid: boolean = false;
  public companyCode: string = '';
  public sourceType: string = '';
  public referralUrl: string = '';
  public referralCode: string = '';
  public userDeviceAppTkn: string = '';
  public duplicateCheckRequired: boolean = true;
  public utmTrackerId!: number;
  public isEmailSystemGenerated: boolean = true;
  public completeRegistration: boolean = false;
  public userAgreement : boolean = false;
  public marketingEmailFlag: boolean = false;
  public enabled: boolean = true;
  public emailVerified: string = 'false';
  public notificationTypeMap={
    "WHATSAPP":false
  };
  public userSourceType :string='';
  public sourceChannelValue: string = 'Talent Portal';
}
